import { render, staticRenderFns } from "./LeafletMap.vue?vue&type=template&id=2b5462d2&scoped=true"
import script from "./LeafletMap.vue?vue&type=script&lang=js"
export * from "./LeafletMap.vue?vue&type=script&lang=js"
import style0 from "./LeafletMap.vue?vue&type=style&index=0&id=2b5462d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5462d2",
  null
  
)

export default component.exports